'use strict';exports.__esModule = true;exports.getCityKey = exports.getMappedLocation = exports.formatLocation = exports.findMappedNeighborhoodLocalization = exports.findMappedCityLocalization = undefined;var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _citiesMap = require('./cities-map.json');var _citiesMap2 = _interopRequireDefault(_citiesMap);
var _neighborhoodsMap = require('../neighborhoods/neighborhoods-map.json');var _neighborhoodsMap2 = _interopRequireDefault(_neighborhoodsMap);
var _constants = require('../../constants');
var _slugify = require('../../helpers/slugify');var _slugify2 = _interopRequireDefault(_slugify);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getLocation = function getLocation(locationSearch, locale) {var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'city_name';return (
    !(0, _isEmpty2.default)(locationSearch[locale]) ? locationSearch[locale][path] : locationSearch.en[path]);};

var findMappedCityLocalization = exports.findMappedCityLocalization = function findMappedCityLocalization(city, locale) {
  var localized = _citiesMap2.default.find(function (item) {return item.key === city;});
  return localized ? localized[locale] : undefined;
};

var findMappedNeighborhoodLocalization = exports.findMappedNeighborhoodLocalization = function findMappedNeighborhoodLocalization(cityKey, neighborhoodKey, locale) {return (
    (0, _get2.default)(_neighborhoodsMap2.default, cityKey + '.' + neighborhoodKey + '.' + locale,
    (0, _get2.default)(_neighborhoodsMap2.default, cityKey + '.' + neighborhoodKey + '.en', '')));};


var formatLocation = exports.formatLocation = function formatLocation(localisedLocation, translate, locale) {
  if (localisedLocation) {
    var location = '' + translate('title', 'in');

    location += locale !== _constants.language.default ? ' ' : '';

    location += localisedLocation;

    return location;
  }

  return null;
};

var getMappedLocation = exports.getMappedLocation = function getMappedLocation(locationSearch, locale) {
  if (locationSearch.unformattedCity) {
    return findMappedCityLocalization(locationSearch.unformattedCity, locale);
  }

  var location = locationSearch[locale] || locationSearch.en;

  if (!(0, _isEmpty2.default)(location) && location.city_name) {
    var cityKey = (0, _slugify2.default)(locationSearch.en.city_name);
    var city = findMappedCityLocalization(cityKey, locale);
    city = city || getLocation(locationSearch, locale);

    var isNeighborhood = locationSearch.isNeighborhood ||
    (location.neighborhood || location.street_name) !== location.city_name;

    var neighborhood = '';
    if (isNeighborhood) {
      var key = (0, _get2.default)(locationSearch, 'en.neighborhood', (0, _get2.default)(locationSearch, 'en.street_name', ''));
      var neighborhoodStreetKey = (0, _slugify2.default)(key);

      neighborhood = neighborhoodStreetKey && findMappedNeighborhoodLocalization(
      cityKey, neighborhoodStreetKey, locale);

      neighborhood = neighborhood || getLocation(locationSearch, locale, 'neighborhood') || '';
    }

    return '' + neighborhood + (neighborhood ? ', ' : '') + city;
  }
  return null;
};

var getCityKey = exports.getCityKey = function getCityKey() {var locationSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (locationSearch.isCity && locationSearch.key) {
    return locationSearch.key;
  }
  var englishName = locationSearch.en && locationSearch.en.city_name;
  if (englishName) {
    return (0, _slugify2.default)(englishName);
  }

  return null;
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/cities/findMappedLocalization.js
// module id = 287
// module chunks = 0